import config from "../_config/config";
import { authHeader } from "../_helpers";
import axios from "axios";

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.put["X-Requested-With"] = "XMLHttpRequest";

export const soapTemplateService = {
  getAll,
  getById,
  create,
  update,
  remove,
};

function getAll(params = {}) {
  return axios
    .get("soap-templates", {
      headers: authHeader(),
      params: params,
    })
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function getById(id) {
  return axios
    .get(`soap-templates/${id}`, { headers: authHeader() })
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function create(data) {
  return axios
    .post("soap-templates", data, { headers: authHeader() })
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function update(id, data) {
  return axios
    .put(`soap-templates/${id}`, data, { headers: authHeader() })
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}

function remove(id) {
  return axios
    .delete(`soap-templates/${id}`, { headers: authHeader() })
    .then((response) => Promise.resolve(response))
    .catch((err) => Promise.reject(err.response));
}
